import { defineComponent as a, computed as o, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as d, createCommentVNode as m, normalizeStyle as h } from "vue";
const _ = ["viewBox"], f = /* @__PURE__ */ t("mask", { id: "77b7369b-3454-4903-bb03-9a7b10765499" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#77b7369b-3454-4903-bb03-9a7b10765499)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "M0 0h512v512H0z"
}, null, -1), g = /* @__PURE__ */ t("path", {
  fill: "#496e2d",
  d: "M407.3 210H291.7L256 100.3 220.3 210H104.7l93.5 68-35.7 109.8L256 320l93.5 68-35.7-110zm-183 59.5 12.2-37.1h39l12.1 37.1-31.6 23-31.6-23zm44-59.4h-24.6l12.3-37.9zm38.3 45.7-7.7-23.4h39.9zM213 232.4l-7.7 23.4-32.2-23.4zm-8.3 97.3 12.3-38 20 14.5zm70.1-23.4 20-14.5 12.3 37.9z"
}, null, -1), v = { fill: "none" }, b = ["r"], y = /* @__PURE__ */ a({
  __name: "ma",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), n = o(() => 256 + e.strokeWidth / 2);
    return (z, x) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      f,
      t("g", u, [
        e.flagName ? (i(), r("title", k, d(e.flagName), 1)) : m("", !0),
        p,
        g
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=ma-1eda5aae.js.map
